import { gql } from '@apollo/client';

export const DELETE_BOARDER_NOTE = gql`
  mutation DeleteBoarderNote($input: DeleteBoarderNoteInput!) {
    deleteBoarderNote(input: $input) {
      boarderId
    }
  }
`;
